<template>
  <div class="md-layout">
    <!-- Sales Chart (Bar Chart) -->
    <div class="md-layout-item md-small-size-100 md-size-66">
      <md-card>
        <md-card-content>
          <div>
            <h3>Sales</h3>
            <p>Sales Performance</p>
            <div class="container_row">
              <div class="layer1"><BarChart /></div>
              <!-- Empty State -->
              <div class="layer2" v-if="isSalesEmpty && !isSalesChartLoading">
                <h4>No data at this moment</h4>
              </div>
              <!-- Loading State -->
              <div class="layer2" v-if="isSalesChartLoading">
                <h4>Loading data ...</h4>
              </div>
            </div>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <p>Sales Breakdown</p>
        </md-card-actions>
      </md-card>
    </div>

    <!-- Performance Chart (Doughnut Chart) -->
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-card>
        <md-card-content>
          <h3>Performance</h3>
          <div>
            <p>Transaction success rate</p>
            <div class="container_row">
              <div class="layer1"><DoughnutChart /></div>
              <!-- Empty State -->
              <div class="layer2" v-if="isPerformanceEmpty && !isPerformanceChartLoading">
                <h4>No data at this moment</h4>
              </div>
              <!-- Loading State -->
              <div class="layer2" v-if="isPerformanceChartLoading">
                <h4>Loading data ...</h4>
              </div>
            </div>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <p>Performance Breakdown</p>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import BarChart from './BarChart.vue';
import DoughnutChart from './DoughnutChart.vue';

export default {
  name: 'dashboard-charts',
  props: ['isPerformanceLoading, isSalesLoading'],
  components: {
    BarChart,
    DoughnutChart,
  },
  computed: {
    isSalesEmpty() {
      const sales = this.$store.state.sales.xAxis;
      const isEmpty = !sales.length;

      return isEmpty;
    },
    isPerformanceEmpty() {
      const { performance } = this.$store.state;
      const sum = performance.reduce((partialSum, a) => partialSum + a, 0);
      const isEmpty = !sum;
      return isEmpty;
    },
    isSalesChartLoading() {
      return this.$store.state.isSalesChartLoading;
    },
    isPerformanceChartLoading() {
      return this.$store.state.isPerformanceChartLoading;
    },
  },
};
</script>

<style scoped>
.container_row {
  position: relative;
}

.layer1 {
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}

.layer2 {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  opacity: 85%;
}
</style>
